// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thLYirLSwGByealqLaZS{width:auto;overflow:hidden;position:relative}`, "",{"version":3,"sources":["webpack://./src/components/cards/defaults/ItemHorizontalCard/components/CardThumbnail/styles.module.sass"],"names":[],"mappings":"AAAA,sBAEE,UAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":[".image\n  // height: 130px\n  width: auto\n  overflow: hidden\n  position: relative\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `thLYirLSwGByealqLaZS`
};
export default ___CSS_LOADER_EXPORT___;
